export default class MultipleChoiceData {
    /**
     * 
     * @param {string} dialogId 
     * @param {string} situationId 
     * @param {string[]} optionIds 
     * @param {number} timeToAnswer - in msecs 
     */
    constructor(episodeId, dialogId, situationId, optionIds, timeToAnswer) {
        this.episodeId = episodeId;
        this.dialogId = dialogId;
        this.situationId = situationId;
        this.optionIds = optionIds;
        this.timeToAnswer = timeToAnswer;
    }
}
